<div class="flex flex-column" style="min-height: 100%; background-color: rgba(221, 223, 223, 1)">
  <div class="page-content-layout" [ngClass]="{ 'mr-4': sidebarVisible }">
    <div class="flex justify-between gap-2 mb-5">
      <ng-content select="[headerContent]"></ng-content>
    </div>
    <ng-content select="[content]"></ng-content>
  </div>

  <ng-content select="[footerContent]"></ng-content>

  <nz-drawer
    [nzClosable]="false"
    [nzVisible]="sidebarVisible"
    (nzVisibleChange)="setSidebarVisible(sidebarVisible)"
    nzPlacement="right"
    [nzWidth]="'456px'"
    (nzOnClose)="setSidebarVisible(false)"
  >
    <ng-container *nzDrawerContent>
      <ng-content select="[collapsibleContent]"></ng-content>
    </ng-container>
  </nz-drawer>
</div>
